import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../redux/slices/loginSlice";
import NotificationBell from "../NotificationBell/NotificationBell";
import AgentFeedbackModal from "../Popups/AgentFeedbackModal";

import monteNidoLogo from "../../../assets/images/MonteNido_Logo.png";
import magicHealthLogo from "../../../assets/images/magicHealthLogo.png";
import { showFeedbackModal } from "../../../redux/slices/notificationSlice";
import { encodeId } from "../../Helper/encdec";

// The Release Notes ("What's New") page is gated on its API being configured.
// Only .env.dev defines REACT_APP_RELEASE_NOTES_API, so the feature is live in
// dev and invisible everywhere else until that var is deliberately added.
const isReleaseNotesEnabled = Boolean(process.env.REACT_APP_RELEASE_NOTES_API);

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const dropdownRef = useRef(null);

  const isLoggedIn = !!localStorage.getItem("authToken");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userName =
    useSelector((state) => state.login?.login?.data?.data?.[0]?.FirstName) ||
    "User";
  const role =
    useSelector((state) => state.login?.login?.data?.data?.[0]?.Role) || "";
  const userData = useSelector((state) => state.login?.login?.data?.data?.[0]);
  const currentUserId =
    userData?.UserId || userData?.AdminID || userData?.AgentID || "";

  // Build a selectedAgent object compatible with AgentFeedbackModal
  const selectedAgent = currentUserId
    ? { value: currentUserId, label: userName }
    : { value: "", label: userName };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        open &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    sessionStorage.removeItem("authToken");
    dispatch(logout());
    navigate("/");
  };

  const handleNotificationClick = (notification) => {
    console.log("Notification clicked:", notification);
    if (
      notification?.NotificationType == "FEEDBACK_REPLY" ||
      notification?.NotificationType == "FEEDBACK"
    ) {
      navigate("/agenthome");
      dispatch(showFeedbackModal(true));
    } else if (
      notification?.NotificationType == "ISSUE_NOTE" ||
      notification?.NotificationType == "ISSUE_ASSIGNED"
    ) {
      const urlParts = notification?.NavigationPath?.split("/") || [];
      const encodedMemberId = encodeId(String(urlParts[1]).replace(/\s+/g, ""));
      const encodedCallId = encodeId(urlParts[2]);
      navigate(`/detailsPage/${encodedMemberId}/${encodedCallId}`, {
        state: { openActionPanel: true },
      });
    }
  };

  return (
    <div className="header-wrapper">
      <header className="header">
        <div className="header-inner">
          <div className="logo-left">
            <NavLink to="/">
              <img
                src={monteNidoLogo}
                alt="Monte Nido"
                className="logo-large"
              />
            </NavLink>
          </div>

          <div className="header-right">
            <div className="powered-section">
              <span className="powered-text">Powered by</span>
              <a
                href="https://magichealth.io/"
                target="_blank"
                rel="noopener noreferrer"
                className="magic-health-link"
              >
                <img
                  src={magicHealthLogo}
                  alt="Magic Health"
                  className="logo-small"
                />
              </a>
            </div>

            {isLoggedIn && (
              <>
                {
                  <>
                    <div className="divider"></div>
                    <NotificationBell
                      onNotificationClick={handleNotificationClick}
                    />
                  </>
                }

                <div className="divider"></div>

                <div className="profile-wrapper" ref={dropdownRef}>
                  <button
                    className="profile-trigger"
                    onClick={() => setOpen((prev) => !prev)}
                  >
                    <div className="avatar">
                      {userName.charAt(0).toUpperCase()}
                    </div>
                    <span className="chevronNav">▼</span>
                  </button>

                  {open && (
                    <div className="dropdown">
                      <div className="dropdown-label">
                        {userName}
                        {role && (
                          <span className="dropdown-role"> ({role})</span>
                        )}
                      </div>
                      <div className="dropdown-separator" />

                      {/* Items with (Coming Soon) and disabled class */}
                      {/* <div className="dropdown-item coming-soon">Profile (Coming Soon)</div>
                      <div className="dropdown-item coming-soon">Settings (Coming Soon)</div>
                      <div className="dropdown-item coming-soon">Help & Support (Coming Soon)</div> */}

                      {/* "What's New" (Release Notes) is shown only where the
                          Release Notes API is configured. REACT_APP_RELEASE_NOTES_API
                          is set in .env.dev only, so the entry appears in dev
                          builds and stays hidden in QA/Production until the env
                          var is added there — no code change needed to ship it,
                          and no way to leak it into a prod build by accident. */}
                      {isReleaseNotesEnabled && (
                        <div
                          className="dropdown-item"
                          onClick={() => {
                            setOpen(false);
                            navigate("/release-notes");
                          }}
                        >
                          What's New
                        </div>
                      )}

                      <div
                        className="dropdown-item logout"
                        onClick={handleLogout}
                      >
                        Log out
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </header>

      {/* ─── Agent Feedback Modal (opened from notification click) ─── */}
      {/* <AgentFeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={() => setIsFeedbackModalOpen(false)}
        selectedAgent={selectedAgent}
      /> */}
    </div>
  );
};

export default Navbar;
